import qs from 'qs';

import { Room } from '@/interfaces/room';
import { BaseService } from './base.service';
import Client from './client';

export class RoomService extends BaseService {
  /**
   * Szukanie pokoi
   *
   * @param {{
   *     start: Date;
   *     end: Date;
   *     adults: number;
   *     children3: number;
   *     children12: number;
   *   }} [query]
   * @returns {Promise<Room[]>}
   * @memberof RoomService
   */
  public search(query?: {
    start: Date;
    end: Date;
    adults: number;
    children3: number;
    children12: number;
    rooms: [];
  }): Promise<Room[]> {
    if (this.mockRequest) {
      return Promise.resolve(roomsMock);
    }

    return Client.get(`/FindAvailableRooms`, {
      params: query,
      paramsSerializer: function (params) {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      }
    }).then(response => response.data.list);
  }

  /**
   * Dane pokoju
   *
   * @param {number} id
   * @param {string} start
   * @param {string} end
   * @returns
   * @memberof RoomService
   */
  public get(id: number, start: string, end: string) {
    if (this.mockRequest) {
      return Promise.resolve(roomsMock.find(room => room.id === id));
    }
    return Client.get(`/getRoom`, { params: { roomId: id, start, end } }).then(response => response.data);
  }

  /**
   * Dodatki dostępne w pokoju
   *
   * @param {number} id
   * @memberof RoomService
   */
  public additions(roomId: number) {
    return Client.get('/FindAddtitions', { params: { roomId } })
      .then(response => response.data)
      .then(additions => {
        additions.forEach((addition: any) => {
          if (!addition.price && addition.additionPrice) {
            addition.price = addition.additionPrice;
          }
        });
        return additions;
      });
  }
}

export default new RoomService();
const roomsMock: Room[] = [
  {
    typeId: 3,
    numberOfAdults: 0,
    numberOfChildren12: 0,
    numberOfChildren3: 0,
    description: '<p>A może tak, a <strong>może</strong> nie</p>\r\n<p>może za trzy minuty, lub za dwie</p>',
    type: { name: 'Test1', id: 3 },
    offerType: 0,
    number: '1',
    name: 'Pierwszy pokój',
    id: 1
  },
  {
    typeId: 4,
    numberOfAdults: 2,
    numberOfChildren12: 0,
    numberOfChildren3: 0,
    description: '<p><strong>Tak</strong>?</p>',
    type: { name: 'Test2', id: 4 },
    offerType: 1,
    number: '2',
    name: 'Drugi pokoj',
    id: 2
  },
  {
    typeId: 4,
    numberOfAdults: 0,
    numberOfChildren12: 0,
    numberOfChildren3: 0,
    description: null,
    type: { name: 'Test2', id: 4 },
    offerType: 0,
    number: '3',
    name: 'Trzeci',
    id: 4
  }
];
